/**
 * SignUpFormWrapper - Wrapper for sign-up form layout
 */

"use client";

import { Flex } from "@chakra-ui/react";
import type { PropsWithChildren } from "react";

export const SignUpFormWrapper = ({ children }: PropsWithChildren) => (
  <Flex
    w="100%"
    mx="auto"
    justify="center"
    direction="column"
    maxW={{ base: "100%", md: "1100px" }}
  >
    {children}
  </Flex>
);

